type E164FormatParams = {
    countryCallingCode: string // e.g. "49"
    nationalNumber: string // e.g. "01726422583" or "172 642 2583"
}

/**
 * Formats into E.164: +<countryCallingCode><nationalNumber>
 * - strips all non-digits
 * - removes duplicated country code if present in the local number
 * - removes leading trunk zeros (0, 00, 000…)
 */
export function formatToE164({ countryCallingCode, nationalNumber }: E164FormatParams): string {
    const cc = countryCallingCode.replace(/\D/g, '') // just digits

    // remove everything that's not a digit from the user input
    let local = nationalNumber.replace(/\D/g, '')

    // Remove leading trunk zeros (e.g. 0172… -> 172…)
    local = local.replace(/^0+/, '')

    // If user already entered a full international number (e.g. 49172...)
    // starting with the country code, strip that prefix.
    if (local.startsWith(cc)) {
        local = local.slice(cc.length)
    }

    return `+${cc}${local}`
}
